// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var ExternalTransactionRequestLogController = function ($scope, externalTransactionRequestLogService) {

    const PageSize = 21;
    
    $scope.loadExternalTransactionRequests = function () {
        let setDefaultDetails = function (result) {
            if (result && result.length > 0) {
                $scope.showDetails(result[0].Id);
            }
        };
        
        $scope.externalTransactionRequests = $scope.paginator(function (options, callback) {
            return externalTransactionRequestLogService.query(options,
                function (result) {
                    callback();
                    setDefaultDetails(result);
                });
        }, {}, PageSize);
    };

    $scope.showDetails = function (id) {
        $scope.selectedLog = $scope.externalTransactionRequests.items.find(request => request.Id === id);
    }

    function init() {
        $scope.selectedLog = null;
        $scope.loadExternalTransactionRequests();
    }

    init();
};

ExternalTransactionRequestLogController.$inject = ['$scope', 'ExternalTransactionRequestLog']
